import createIcon from '@/lib/create-icon'

export const DollarCellIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <path
      d='M13.125 5.99988H14.25M3.75 11.9999H4.875M14.7084 13.8916C13.4156 13.633 12.0844 13.633 10.7916 13.8916L7.57219 14.5354C6.03924 14.842 4.46076 14.842 2.92781 14.5354C2.0976 14.3694 1.5 13.6404 1.5 12.7938V5.57699C1.5 4.63176 2.36476 3.92283 3.29163 4.1082C4.58441 4.36676 5.91559 4.36676 7.20837 4.1082L10.4278 3.46432C11.9608 3.15773 13.5392 3.15773 15.0722 3.46432C15.9024 3.63036 16.5 4.35931 16.5 5.20596V12.4228C16.5 13.368 15.6352 14.0769 14.7084 13.8916ZM11.25 8.99988C11.25 10.2425 10.2426 11.2499 9 11.2499C7.75736 11.2499 6.75 10.2425 6.75 8.99988C6.75 7.75724 7.75736 6.74988 9 6.74988C10.2426 6.74988 11.25 7.75724 11.25 8.99988Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'DollarCellIcon'
)
